import { render } from "./AutomationConfigCard.vue?vue&type=template&id=9feffc86&scoped=true&ts=true"
import script from "./AutomationConfigCard.vue?vue&type=script&lang=ts"
export * from "./AutomationConfigCard.vue?vue&type=script&lang=ts"

import "./AutomationConfigCard.vue?vue&type=style&index=0&id=9feffc86&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9feffc86"]])

export default __exports__